export interface DevToArticle {
  id: number;
  type_of?: string;
  title: string;
  description?: string;
  url: string;
  cover_image?: string | null;
  social_image?: string;
  published_at?: string;
  published_timestamp?: string;
  reading_time_minutes?: number;
}

const DEVTO_USERNAME = 'jairo-dev-jr';
const DEVTO_PROXY_ENDPOINT = '/api/dev-to-articles?page=1&per_page=20';
const DEVTO_PUBLIC_ENDPOINT = `https://dev.to/api/articles?username=${DEVTO_USERNAME}&page=1&per_page=20`;
const MIN_READING_TIME_MINUTES = 3;

function getPublishedDate(article: DevToArticle): number {
  const date = article.published_timestamp || article.published_at;
  return date ? new Date(date).getTime() : 0;
}

async function fetchArticleList(endpoint: string): Promise<DevToArticle[]> {
  const response = await fetch(endpoint, {
    headers: {
      accept: 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error(`Failed to load Dev.to articles: ${response.status}`);
  }

  const data = (await response.json()) as unknown;

  if (!Array.isArray(data)) {
    throw new Error('Unexpected Dev.to articles response');
  }

  return data as DevToArticle[];
}

export async function fetchDevToArticles(): Promise<DevToArticle[]> {
  try {
    return await fetchArticleList(DEVTO_PROXY_ENDPOINT);
  } catch {
    return fetchArticleList(DEVTO_PUBLIC_ENDPOINT);
  }
}

export function getLongFormArticles(articles: DevToArticle[]): DevToArticle[] {
  return articles
    .filter((article) => article.type_of === 'article' && (article.reading_time_minutes ?? 0) >= MIN_READING_TIME_MINUTES)
    .sort((a, b) => getPublishedDate(b) - getPublishedDate(a));
}
